import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'app-ai-summary',
  standalone: true,
  imports: [CommonModule, AvatarModule],
  template: `
    <div class="ai-summary-container">
      <div class="ai-summary-header">
        <p-avatar
          label="PP"
          shape="circle"
          size="normal"
          styleClass="patty-avatar"
        ></p-avatar>
        <div class="ai-header-text">
          <div class="ai-title">From Pathway Patty</div>
          <div class="ai-subtitle">Your personalized career guide</div>
        </div>
      </div>
      <div class="ai-summary-content">
        <p>{{ summary }}</p>
      </div>
    </div>
  `,
  styles: [
    `
      .ai-summary-container {
        background-color: #ffffff;
        border-radius: 8px;
        padding: 1.5rem;
        margin-bottom: 1rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      }

      .ai-summary-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #e5e5e5;
      }

      .ai-header-text {
        flex: 1;
      }

      .ai-title {
        font-weight: 600;
        font-size: 1rem;
        color: #000000;
        margin-bottom: 0.25rem;
      }

      .ai-subtitle {
        font-size: 0.85rem;
        color: #666666;
      }

      .ai-summary-content {
        color: #333333;
        line-height: 1.6;
      }

      .ai-summary-content p {
        margin: 0;
      }

      :host ::ng-deep {
        .patty-avatar {
          background-color: #ff6b6b;
          color: #ffffff;
          font-weight: 600;
        }
      }
    `,
  ],
})
export class AISummaryComponent {
  @Input() summary: string = '';
}

